import type { RouteRecordRaw } from 'vue-router'

// 로그인 여부와 무관하게 열람 가능해야 한다 — 가입 전(회원가입 화면 체크박스) 방문자도
// 약관/개인정보처리방침을 읽을 수 있어야 하므로 requiresAuth를 걸면 안 된다
// (걸면 미로그인 상태에서 클릭 시 로그인 화면으로 리다이렉트되는 버그가 생김).
export const legalRoutes: RouteRecordRaw[] = [
  {
    path: '/terms',
    name: 'LegalTerms',
    component: () => import('./views/LegalDocumentPage.vue'),
    meta: { title: 'common.legalConsent.linkTerms', requiresAuth: false, layout: 'blank', docType: 'terms' },
  },
  {
    path: '/privacy',
    name: 'LegalPrivacy',
    component: () => import('./views/LegalDocumentPage.vue'),
    meta: { title: 'common.legalConsent.linkPrivacy', requiresAuth: false, layout: 'blank', docType: 'privacy' },
  },
  {
    path: '/dpa',
    name: 'LegalDpa',
    component: () => import('./views/LegalDocumentPage.vue'),
    meta: { title: 'common.legalConsent.linkDpa', requiresAuth: false, layout: 'blank', docType: 'dpa' },
  },
]
